import { render, staticRenderFns } from "./TableNew.vue?vue&type=template&id=e6b55c9a&"
import script from "./TableNew.vue?vue&type=script&lang=js&"
export * from "./TableNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports